import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { FlightEventClient, FlightEventReportDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightEventClient = new FlightEventClient(apiBaseUrl);

function useSubmitFlightEvent() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<FlightEventReportDTO, ProblemDetails, number>({
    mutationKey: [queryKeys.FlightEvent.Submit],
    mutationFn: (reportId: number) => flightEventClient.submit(reportId),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useSubmitFlightEvent;
